<template>
  <div class="container-fluid">
    <div class="spinner-cover" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <div class="spinner-cover-new" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <!-- NAV ON Dokumentation TODO: FIX ALIGNMENT -->
    <div class="button-areas">
      <div class="row border-bottom pt-2 pb-2">
        <div class="col-xl-3 col-lg-4 col-md-4 pl-1 pl-md-0 pl-lg-1 pr-0">
          <button type="button"  v-if="isSideBarActive" @click="toggleSideBar(false)" class="btn btn-light filter-btn filter-icon-sidebar ml-1" style="background: dodgerblue;color: white !important;" :class="{hidden: $route.name === 'photoDocumentCreate'}" v-show="$route.name !== 'photoDocumentEdit'">
            <img class="plus-img" src="@/assets/images/img-icons/filter2_white.svg" alt="img">
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
          <span class="icons-text-top-bar"> Filter</span>
          </button>

          <button type="button" v-else @click="toggleSideBar(true)"  class="btn btn-light filter-btn filter-icon-sidebar ml-1" :class="{hidden: $route.name === 'photoDocumentCreate'}" v-show="$route.name !== 'photoDocumentEdit'">
            <img class="plus-img"  src="@/assets/images/img-icons/filter2_black.svg" alt="img" >
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
          <span class="icons-text-top-bar"> Filter</span>
          </button>

          <button type="button" class="btn btn-light active ml-1"> {{$t('documentation')}} </button>
          <button type="button" class="btn btn-light simple-photo-check ml-1" @click="$router.push({ name: 'constructionDocs' })">
            {{$t('construction_diaries')}}
          </button>
        </div>

        <!--         Date Range Slider Start Here-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12 photo-top-midle pr-0 pl-1">-->
<!--          <div class="w-100" v-if="$route.name !== 'photoDocumentEdit' && $route.name !== 'photoDocumentCreate'">-->
<!--            <div class="row m-0">-->
<!--              <div class="col-md-3 p-0 pr-2">-->
<!--                <div class="d-flex date float-right date-pick datepicker mr-1" data-date-format="dd.mm.yyyy">-->
<!--                  <span class="input-group-addon this-calender font1rem ">-->
<!--                    <i class="fa-regular fa-calendar-minus"></i></span>-->
<!--                  <input id="from" data-date-format="dd.mm.yyyy"-->
<!--                         class="form-control date-input ml-1"-->
<!--                         v-model="dateRangeFrom" type="text" readonly="">-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-6 p-0">-->
<!--                <div class="filter w-100 level-filter level-req">-->
<!--                  &lt;!&ndash;            Date Range Slider&ndash;&gt;-->
<!--                  <input type="text" class="js-range-slider" id="rangeSliderInPhotoDocs" name="my_range" value="" />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-3 p-0">-->
<!--                <div class="d-flex date date-pick datepicker ml-1" data-date-format="dd.mm.yyyy">-->
<!--                  <input id="to" data-date-format="dd.mm.yyyy"-->
<!--                         class="form-control date-input ml-1"-->
<!--                         v-model="dateRangeTo"  type="text" readonly="">-->
<!--                  <span class="input-group-addon this-calender ml-1 font1rem">-->
<!--                    <i class="fa-regular fa-calendar-minus"></i></span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="col photo-top-midle">
<!--          <div class="w-100" v-if="$route.name !== 'photoDocumentEdit' && $route.name !== 'photoDocumentCreate'">-->
          <div id="datepicker_f" class="d-flex input-group this-calender input-group-sm date mr-2 ml-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <div class="input-group-prepend">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
            <input id="datepicker_from"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeFrom"
                   :disabled="!dateRangeFrom"
                   readonly="">
          </div>

          <div class="filter level-filter level-req">
            <input type="text" class="js-range-slider" id="rangeSliderInPhotoDocs" name="my_range" value="" />
          </div>

          <div id="datepicker_t" class="d-flex input-group this-calender input-group-sm date ml-2 mr-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <input id="datepicker_to"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeTo"
                   :disabled="!dateRangeTo"
                   readonly="" style="margin-top: 0">
            <div class="input-group-append">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
          </div>
<!--            </div>-->
        </div>
        <!--         Date Range Slider Ends Here-->
        <div class="right-btn col-xl-3 col-lg-1 col-md-1 col-sm-2 text-right d-none d-sm-block pl-0 pr-md-1 pr-2 pb-0">
<!--          <router-link  class="btn btn-light mb-1" :class="{'inactive': $route.name !== 'photoDocumentation'}"  :to="{name: 'photoDocumentation',params: {id: $route.params.id}}">-->
<!--            {{$t('overview')}}-->
<!--          </router-link>-->
<!--          <router-link :to="{name: 'photoDocumentationPreview', params: {id: $route.params.id ,docId: selectedDoc.pdreportid || 0}}" :class="$route.name === 'photoDocumentationPreview' ? 'active': ''" class="btn btn-light ml-1 mr-2 mr-md-1 mt-0 mb-1">-->
<!--            {{$t("preview")}}-->
<!--          </router-link>-->
          <template v-if="usercan('editor') && $route.name !== 'photoDocumentCreate' && photoDocuments.length > 0">
            <a @click.prevent="changeEditMode" href="#"  id="edit-sidebtn" class="btn btn-light mr-1" :class="{active: $route.name === 'photoDocumentEdit'}">
              <i class="fa-regular fa-pen-to-square font14" aria-hidden="true" style="font-size: 0.82rem"></i>
              <span class="icons-text-top-bar"> {{$t("edit")}} </span>
            </a>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
export default {
  components: {},
  props: ['range'],
  name: 'TopBar',
  data () {
    return {
      searchString: '',
      is_active: this.$parent.isSideBarActive,
    }
  },
  mounted () {
      this.setDatePickers();
  },
  computed: {
    ...mapState({
      photoDocuments: state => state.photoDocumentation.photoDocuments,
      isSideBarActive: state => state.photoDocumentation.isSideBarActive,
      isDetailsActive: state => state.photoDocumentation.toggleRightTab,
      isLoading: state => state.photoDocumentation.isLoading,
      isEdit: state => state.photoDocumentation.isEdit,
      selectedDoc: state => state.photoDocumentation.selectedDocument,
      selectedDocCopy: state => state.photoDocumentation.documentDetailsCopy,
      photos: state => state.photo.photos,
      meta: state => state.photoDocumentation.photoDocsMeta
    }),

    dateRangeFrom: {
      get () {
        return this.$store.state.photoDocumentation.photoDocsMinimumDate
      },
      set(val){
         this.$store.commit('setPhotoDocsMetaDateFrom',val)
      }
    },
    dateRangeTo: {
      get () {
        return  this.$store.state.photoDocumentation.photoDocsMaximumDate
      },
      set(val){
        this.$store.commit('setPhotoDocsMetaDateTo', val)
      }
    },

    dateTo: {
      get () {
        return this.$store.state.photoDocumentation.dateRangeTo
      },
      set (val) {
        this.$store.commit('setDateRangeTo', val)
      }
    },

    dateFrom: {
      get () {
        return this.$store.state.photoDocumentation.dateRangeFrom
      },
      set (val) {
        this.$store.commit('setDateRangeFrom', val)
      }
    }
  },
  methods: {
    changeEditMode(){
      if (!this.selectedDoc.pdreportid && this.photoDocuments.length > 0){
        this.$store.commit('setSelectedDocument', this.photoDocuments[0])
      }
     const link = {
       name: 'photoDocumentEdit',
       params: {id: this.$route.params.id ,docId: this.selectedDoc.pdreportid || 0}
     }
     if (this.$route.name === 'photoDocumentEdit'){
       this.$root.$emit('updateEdit');
     }else {
       this.$router.push(link)
     }
    },

    async setDatePickers () {
      let _this = this
      await this.setDateRangeSlider();
      let my_range = $("#rangeSliderInPhotoDocs").data("ionRangeSlider");
      // $('.datepicker').datepicker({
        $('#datepicker_to, #datepicker_from').datepicker({
        autoclose: true,
        todayHighlight: true
      }).change(function (event){
        const value = event.target.value;
        const from =  moment(_this.meta.minimumDate,'DD.MM.YYYY');
        if (event.target.getAttribute('id') === 'datepicker_from'){
          const dif_from = moment(value , 'DD.MM.YYYY');
          const dif = moment.duration(dif_from.diff(from)).asDays();
          my_range.update({ from: Math.floor(dif)});
        } else {
          const to =  moment(_this.meta.maximumDate,'DD.MM.YYYY');
          const dif_to = moment(value , 'DD.MM.YYYY');
          const difToDate = moment.duration(dif_to.diff(to)).asDays();
          my_range.update({ to: Math.floor(_this.range[1] + difToDate)});
        }

          const d_from = $('#datepicker_from').val();
          const d_to = $('#datepicker_to').val();
          _this.dateFrom = d_from;
          _this.dateTo  = d_to;
          _this.dateRangeFrom = d_from;
          _this.dateRangeTo  = d_to;
        });
      this.$store.commit('toggleLoading',false)
    },

    setDateRangeSlider(){
      const _this = this
      $(".js-range-slider").ionRangeSlider({
        type: "double",
        min: Array.isArray(_this.range) ? _this.range[0] : 0,
        max: Array.isArray(_this.range) ? _this.range[1] : 1,
        drag_interval: true,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: function (val){
          _this.setDateRanges(val);
          _this.onSliderChangeStep(val);
        },
        onChange: function (val){
          _this.onSliderChangeStep(val);
        }
      });
    },

    setDateRanges (val) {
      const from = val.from
      const to = val.to
      this.dateFrom = moment(this.meta.minimumDate,'DD.MM.YYYY').add(from,'day').format('DD.MM.YYYY');
      this.dateTo = moment(this.meta.maximumDate,'DD.MM.YYYY').add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },

    onSliderChangeStep(val){
      const from = val.from;
      const to = val.to;
      this.dateRangeFrom = moment(this.meta.minimumDate,'DD.MM.YYYY').add(from,'day').format('DD.MM.YYYY');
      this.dateRangeTo = moment(this.meta.maximumDate,'DD.MM.YYYY').add(to  - this.range[1], 'day').format('DD.MM.YYYY')
    },


    toggleSideBar (value) {
      this.$store.commit('toggleSideNav', value)
      this.$store.commit('toggleRightTab', false)
    },

    toggleDetails () {
      let flag = !this.isDetailsActive
      this.$store.commit('toggleRightTab', flag)
      this.$store.commit('toggleSideNav', false);
      this.toggleEditMode(false);
      this.$store.commit('setIsEditDocsModule', false);
    },
    showOverview () {
      this.$store.commit('toggleRightTab', false)
      this.toggleEditMode(false);
      this.$store.commit('setIsEditDocsModule', false);
      this.doc = this.selectedDocCopy
    },
    openNav () {
      this.is_active = false
    },

    //Toggle Edit In Docs Module ........
    setEditDoc(){
      let flag  = !this.isEdit
      this.$store.commit('toggleRightTab', false);
      this.$store.commit("setIsEditDocsModule",flag);
      this.toggleEditMode(flag);
    },


    toggleEditMode(flag){
      if (flag){
        this.$store.commit('toggleDetailsTab', true);
        this.$store.commit('toggleMainDetailsTab', false);
        this.doc = this.selectedDoc;
      }else {
        this.$store.commit('toggleDetailsTab', false);
        this.$store.commit('toggleMainDetailsTab', true);
        this.doc = this.selectedDocCopy
      }
    }
  },
}
</script>
<style scoped type="text/css">
.active{
  color: white !important;
  background: dodgerblue !important;
}
.slider-horizontal{
  padding: 7px 4px !important;
}
.inactive{
  color: black !important;
  background: white !important;
}
</style>
<style>
.btn-light:hover{
  color: white !important;
  background: dodgerblue !important;
}
.hidden{
  visibility: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/TopBar.vue